// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieInfo_container__1a2_9"};